import { preload } from "./include/module";
import { autoPlay } from "./include/module";
import { anchorLink } from "./include/module";
import { charaSlider } from "./include/module";
import { movieModal } from "./include/module";
import { imageModal } from "./include/module";
import { toggleMenu } from "./include/module";
import { scrollAnime } from "./include/module";
import { loadAnime } from "./include/module";





(() => {

  preload();
  autoPlay();
  anchorLink();
  charaSlider();
  movieModal();
  imageModal();
  toggleMenu();
  scrollAnime();
  loadAnime();

})();



// WEBPACK FOOTER //
// ./src/assets/js/script.js